import { memo, useCallback } from "react"
import { Handle, Position } from "@xyflow/react"
import { getTeamColor } from "./teams"
import EditableLabel from "../EditableLabel"
import { useNodeContext } from "../NodeContext"

const ProcessNode = memo(({ id, data, selected }) => {
  const teamColor = getTeamColor(data.team)
  const hasDrillDown = data.drillDownSlug
  const hasCoverage = data.sources?.expected?.tests?.length > 0
  const { onLabelChange } = useNodeContext()

  const handleLabelSave = useCallback((newLabel) => {
    onLabelChange(id, newLabel)
  }, [id, onLabelChange])

  return (
    <div className={`process-node ${selected ? "selected" : ""}`}>
      <Handle type="target" position={Position.Left} id="target-left" />
      <Handle type="target" position={Position.Top} id="target-top" />

      <EditableLabel
        value={data.label}
        onSave={handleLabelSave}
        className="node-label"
      />

      {(teamColor || hasDrillDown || hasCoverage) && (
        <div className="node-badges">
          {hasDrillDown && <span className="drill-badge">+</span>}
          {hasCoverage && <span className="coverage-badge">✓</span>}
        </div>
      )}

      {teamColor && (
        <div className="team-badge" style={{ backgroundColor: teamColor }} />
      )}

      <Handle type="source" position={Position.Right} />
      <Handle type="source" position={Position.Bottom} id="bottom" />
    </div>
  )
})

ProcessNode.displayName = "ProcessNode"

export default ProcessNode
